/* eslint-disable no-unused-vars */
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { UserDataType } from '../types';

export const useUserStore = create(
  persist(
    (set) => ({
      name: '',
      email: '',
      userId: '',
      tenantId: '',
      isActiveMfa: false,
      isVerifiedMfa: false,
      setUserStore: (user: UserDataType) =>
        set({
          name: user.name,
          email: user.email,
          tenantId: user.tenantId,
          userId: user.userId,
          isActiveMfa: user.is_active_mfa,
        }),
      setNewNameUserStore: (name: string) => set({ name }),
      setNewEmailUserStore: (email: string) => set({ email }),
      setIsActiveMfaUserStore: (isActiveMfa: boolean) => set({ isActiveMfa }),
      setIsVerifiedMfaUserStore: (isVerifiedMfa: boolean) =>
        set({ isVerifiedMfa }),
    }),
    {
      name: 'useUserStore',
    },
  ),
);
